import {AppBar, Toolbar, Typography, Button, Container, Box, IconButton, MenuItem, Menu} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import {Link} from 'react-router-dom';
import React from 'react';
import {ReactComponent as Logo} from '../StarryNights_Logo_Small.svg'

const pages = [
    {name: 'Home', route: "/"},
    {name: 'Line-up', route: "/line-up"},
    {name: 'FAQ', route: "https://www.sfu.ca/science/community/trottier-observatory---courtyard/starry-nights.html", external: true }

];

function Navbar() {

    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                        <Link to="/" style={{textDecoration: 'none', color: 'inherit'}}>
                            <Logo style={{height: '60px', paddingTop: '5px'}}/>
                        </Link>
                    </Typography>
                    <Box sx={{flexGrow: 1, justifyContent: 'flex-end', paddingRight: '10 px', display: {xs: 'flex', md: 'none'}}}>
                        <IconButton
                            size="large"
                            aria-label="menu-options"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Menu
                            id="menu-options"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {xs: 'block', md: 'none'},
                            }}
                        >
                            {pages.map((page) => (
                                page.external ? (
                                    <MenuItem key={page.name} onClick={handleCloseNavMenu} sx={{ paddingInline: '25px' }}>
                                        <Typography textAlign="center">
                                            <a href={page.route} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>{page.name}</a>
                                        </Typography>
                                    </MenuItem>
                                ) : (
                                    <MenuItem component={Link} to={page.route} key={page.name} onClick={handleCloseNavMenu} sx={{ paddingInline: '25px' }}>
                                        <Typography textAlign="center">{page.name}</Typography>
                                    </MenuItem>
                                )
                            ))}
                        </Menu>
                    </Box>
                    <Box sx={{flexGrow: 1, justifyContent: 'flex-end',  paddingRight: '10 px', display: {xs: 'none', md: 'flex'}}}>
                        {pages.map((page) => (
                            <Button color="inherit" sx={{paddingInline: '25px'}} key={page.name}>
                                <Link to={page.route} style={{textDecoration: 'none', color: 'inherit'}}>{page.name}</Link>
                            </Button>
                        ))}
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default Navbar;